// Bootstrap JS
var bootstrap = require("bootstrap");

$(".carousel").carousel();

document.addEventListener("DOMContentLoaded", function () {
  window.addEventListener("scroll", function () {
    if (window.scrollY > 400) {
      document.getElementById("navbar_top").classList.add("fixed-top");
      // add padding top to show content behind navbar
      navbar_height = document.querySelector(".navbar").offsetHeight;
      document.body.style.paddingTop = navbar_height + "px";
    } else {
      document.getElementById("navbar_top").classList.remove("fixed-top");
      // remove padding top from body
      document.body.style.paddingTop = "0";
    }
  });
});

// Hide Header on on scroll down

var scrollTimeOut = true,
  lastYPos = 0,
  yPos = 0,
  yPosDelta = 5,
  nav = $("#navbar_top"),
  navHeight = nav.outerHeight(),
  setNavClass = function () {
    scrollTimeOut = false;
    yPos = $(window).scrollTop();

    if (Math.abs(lastYPos - yPos) >= yPosDelta) {
      if (yPos > lastYPos && yPos > navHeight) {
        nav.addClass("hide-upper-nav");
      } else {
        nav.removeClass("hide-upper-nav");
      }
      lastYPos = yPos;
    }
  };

$(window).scroll(function (e) {
  scrollTimeOut = true;
});

setInterval(function () {
  if (scrollTimeOut) {
    setNavClass();
  }
}, 250);

$(function () {
  $("#myTab li:last-child a").tab("show");
});
